<template>
  <LoadingApi />
  <GlobalToast />

  <!-- Regular confirm dialog -->
  <ConfirmDialog group="info" class="c-confirm-dialog-info" />

  <!-- Refund confirm dialog -->
  <ConfirmDialog group="refund" class="c-confirm-dialog-refund" />

  <!-- Confirm dialog group for danger actions (such as delete) -->
  <ConfirmDialog group="danger" class="c-confirm-dialog-danger" />
  <router-view />
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useSetLanguage } from '@centric-os/platform/i18n';
import { useModuleI18n } from '@centric-os/platform/i18n/composables/useModuleI18n';
import brandManagementEn from '@centric-os/brand-management/src/locale/en';
import brandManagementFr from '@centric-os/brand-management/src/locale/fr';
import { useAuthStore } from '@centric-os/stores/auth/use-auth-store';
import { heap } from '@centric-os/helpers/src/analytics';
import { zendesk } from '@centric-os/helpers/src/zendesk';
import { cdlApi } from '@centric-os/app/src/api';

// Brand-management components are rendered cross-module from global/local
// menu-groups routes that don't register brand-management's locale themselves.
// Registering at the app shell (mounts before any route) keeps those keys
// available wherever the components surface.
useModuleI18n(brandManagementEn, brandManagementFr);

const authStore = useAuthStore();
const { cdlUser, usedSSO } = storeToRefs(authStore);
useSetLanguage();

authStore.zendesk = zendesk(cdlApi);
heap().init(cdlUser, usedSSO, authStore.getRole, authStore.hasRole, cdlApi);
</script>
